import React from 'react';
import { SvgIcon } from 'core/icons';
import { combineClassNames } from 'core/css';

const Spinner = ({ className }) => {
  return (
    <div className={combineClassNames('spinner', className)}>
      <SvgIcon name="spinner" className="spinner__icon svg-icon--option" />
    </div>
  );
};

export default Spinner;
